import React from "react";
import '../../pages/pages.css'

const Button = ({ Text, onClick, Type = "button",Disabled = false }) => {
  return (
    <button className="botao_form" type={Type} onClick={onClick} disabled={Disabled}>
      {Text}
    </button>
  );
};

export default Button;